<template>
  
  <div class="stylist-info-wrapper">
    <div class="stylist-info-card">
        <!-- Close Button -->
      <button class="close-btn" @click="close">
        &times;
      </button>

      <h2 class="stylist-info-title">Stylist {{fullName}}</h2>
      <p class="stylist-info-subtitle">Manage and Change the role of stylist</p>

      <section class="stylist-info-section">
        <h3 class="section-heading">General Details</h3>
        <form @submit.prevent="handleSaveDetails">
          
          <div class="form-group">
            <label for="full-name">Full Name</label>
            <input type="text" id="full-name" v-model="fullName" required :disabled="isLoading">
          </div>
          
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" v-model="email" required :disabled="isLoading">
          </div>

          <div class="form-group">
            <label for="phoneNumber">Phone Number</label>
            <input type="text" id="phoneNumber" v-model="phoneNumber" required :disabled="isLoading">
          </div>

          <div class="form-group">
            <label for="role">Role</label>
            <input type="text" id="role" v-model="role" required :disabled="isLoading">
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>

export default {
    name: 'EditStylist',
    props: {
        stylistData: { 
            type: Object,
            required: true
        }
    },
    created() {
        this.loadStylistInfo()
    },
     watch: {
        stylistData: {
            handler() {
                this.loadStylistInfo()
            },
            deep: true, // Check for deep changes if structure is complex
            immediate: true // Run immediately on creation
        }
    },
    data() {
        return {
            fullName: null,
            email: null,
            phoneNumber: null,
            role: null,
            isLoading: false,

            // Add messages for future API cal;ls
            successMessage: null,
            errorMessage: null,
        }
    },
    methods: {
        loadStylistInfo() {
            // This loads the stylist info from the prop into state variables which then change the value of the v-model
            this.fullName = this.stylistData.full_name
            this.email = this.stylistData.email
            this.phoneNumber = this.stylistData.phone_number
            this.role = this.stylistData.role
        },
        close() {
            this.$emit('close-modal')
        }
    }
}
</script>

<style scoped>

/* Afrochic Color Variables (replicated from AdminProfile and Dashboard) */
:root {
    --color-maroon: crimson; /** or hex code #5D0E1F */ /* Using crimson as the main Afrochic maroon */
    --color-gold: #FBBF24;      
    --color-earth: #A0522D;     
    --color-dark: #1c1917;      
    --color-light: #f5f5f4;     
}

.stylist_info-wrapper {
    margin-top: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
}

.stylist-info-card {
    position: relative; /** For absolute positioning of close button */
    max-width: 900px;
    margin: 0 auto;
    padding: 35px;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    background-color: white;
    border-top: 5px solid var(--color-gold); /* Gold accent top */

    padding: 2.5rem;
}

.close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 1.8rem;
    color: #888;
    cursor: pointer;
    line-height: 1;
    padding: 5px 10px;
    border-radius: 50%;
    transition: color 0.2s, background-color 0.2s;
}

.close-btn:hover {
    color: var(--color-maroon);
    background-color: var(--color-light);
}

.stylist-info-title {
    color: var(--color-dark);
    text-align: center;
    margin-bottom: 5px;
    font-size: 2.2rem;
    font-weight: 800;
}

.stylist-info-subtitle {
    text-align: center;
    color: #777;
    margin-bottom: 30px;
    font-size: 1rem;
}

.section-heading {
    font-size: 1.5rem;
    color: var(--color-maroon);
    border-bottom: 2px solid var(--color-gold); 
    padding-bottom: 8px;
    margin-bottom: 20px;
    font-weight: 700;
}

.form-group {
    margin-bottom: 18px;
}

.form-group label {
    display: block;
    margin-bottom: 6px;
    font-weight: 600;
    color: #333;
    font-size: 0.95rem;
}

.form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    box-sizing: border-box; 
    transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus {
    border-color: var(--color-maroon);
    outline: none;
    box-shadow: 0 0 0 3px rgba(220, 20, 60, 0.1);
}

.section-divider {
    border: 0;
    height: 1px;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), var(--color-earth), rgba(0, 0, 0, 0));
    margin: 30px 0;
}

/* Action Buttons 
.action-group {
    margin-top: 25px;
    text-align: right;
}

.profile-action-btn {
    padding: 10px 25px;
    border: none;
    border-radius: 25px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.save-btn {
    background-color: #A0522D;
    color: white;
}
.save-btn:hover:not(:disabled) {
    background-color: #8d4523;
    transform: translateY(-1px);
}

.password-btn {
    background-color: var(--color-maroon);
    color: white;
}
.password-btn:hover:not(:disabled) {
    background-color: #c0003c;
    transform: translateY(-1px);
}

.profile-action-btn:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
}

/* Messages 
.error-message {
    color: #e74c3c;
    background-color: #fde8e8;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 20px;
    text-align: center;
    border: 1px solid #e74c3c;
}

.success-message {
    color: #27ae60;
    background-color: #e6f9ed;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 20px;
    text-align: center;
    border: 1px solid #27ae60;
}*/

</style>